import type { SVGProps } from 'react';
const SvgEnvironment = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 30" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.947.947a1.688 1.688 0 0 0-3.032 0L.17 20.89a1.687 1.687 0 0 0 1.517 2.428h8.144v4.296a1.688 1.688 0 0 0 3.375 0v-4.296h7.967a1.687 1.687 0 0 0 1.517-2.428zM4.39 19.944l7.04-14.412 7.042 14.412z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEnvironment;
